import { Link } from "react-router-dom";
import { mockPosts } from "@/mocks/social";

const platformIcon: Record<string, string> = {
  tiktok: "ri-tiktok-line",
  youtube: "ri-youtube-line",
  twitter: "ri-twitter-x-line",
};

const platformColor: Record<string, string> = {
  tiktok: "text-gray-900",
  youtube: "text-red-600",
  twitter: "text-gray-800",
};

export default function SocialPreview() {
  return (
    <section className="py-16 px-6 md:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
          <div>
            <h2 className="text-3xl font-bold text-gray-900">Community Feed</h2>
            <p className="text-gray-500 text-sm mt-1">Real people, real products, real stories</p>
          </div>
          <Link
            to="/social"
            className="flex items-center gap-1.5 text-orange-500 font-semibold text-sm hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Posts <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {mockPosts.slice(0, 3).map((post) => (
            <div key={post.id} className="bg-white border border-gray-100 rounded-xl overflow-hidden hover:border-orange-200 transition-colors">
              {/* Post Image */}
              <div className="aspect-video overflow-hidden">
                <img
                  src={post.image}
                  alt={post.user}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Post Content */}
              <div className="p-4">
                {/* User */}
                <div className="flex items-center gap-2.5 mb-3">
                  <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                    <img src={post.avatar} alt={post.user} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1.5">
                      <span className="text-sm font-semibold text-gray-900 truncate">{post.user}</span>
                      {post.role === "influencer" && (
                        <i className="ri-verified-badge-fill text-orange-500 text-xs flex-shrink-0" />
                      )}
                    </div>
                    <div className="flex items-center gap-1.5">
                      <span className="text-xs text-gray-400">{post.username}</span>
                      {post.platform && (
                        <i className={`${platformIcon[post.platform]} ${platformColor[post.platform]} text-xs`} />
                      )}
                      {post.followers && (
                        <span className="text-xs text-gray-400">{post.followers}</span>
                      )}
                    </div>
                  </div>
                  <span className="text-xs text-gray-400 flex-shrink-0">{post.time}</span>
                </div>

                <p className="text-sm text-gray-700 line-clamp-2 mb-3 leading-relaxed">{post.content}</p>

                {/* Engagement */}
                <div className="flex items-center gap-4 text-gray-400 text-sm">
                  <button className="flex items-center gap-1 hover:text-red-500 transition-colors cursor-pointer">
                    <i className="ri-heart-line" />
                    <span className="text-xs">{(post.likes / 1000).toFixed(1)}K</span>
                  </button>
                  <button className="flex items-center gap-1 hover:text-orange-500 transition-colors cursor-pointer">
                    <i className="ri-chat-1-line" />
                    <span className="text-xs">{post.comments}</span>
                  </button>
                  <button className="flex items-center gap-1 hover:text-green-500 transition-colors cursor-pointer">
                    <i className="ri-share-line" />
                    <span className="text-xs">{post.shares}</span>
                  </button>
                  {post.tagged.length > 0 && (
                    <button className="ml-auto flex items-center gap-1 text-orange-500 text-xs font-semibold hover:text-orange-600 cursor-pointer whitespace-nowrap">
                      <i className="ri-shopping-bag-line" /> Shop
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
